import { RESTUtils } from '@galigeo-store/ui-lib';
import { PortalAppContext } from '../state/portal-appcontext';
import { GaligeoCloudService } from './galigeo-cloud.service';

export class MenuService {
  public static async getMenu(): Promise<any[]> {
    const lang = PortalAppContext.getCurrentUser()?.lang || 'en';
    let menu = await RESTUtils.getJson(
      `${PortalAppContext.getBackendUrl()}/feature/menu?lang=${lang}`,
      {},
    );

    // `/feature/portal/modules` is a RIGHTS FILTER, nothing more: it says which
    // menu items the user is entitled to, and we strip the rest.
    //
    // We deliberately do NOT adopt `module.url`. That registry is
    // environment-blind — it answers the same URLs whichever portal asks — so
    // adopting them made the dev and staging portals load the PRODUCTION
    // front-ends, silently defeating every `*_FRONTEND_URL` the backend
    // resolves per GitHub environment. The URL stays the backend's.
    try {
      const modules = await GaligeoCloudService.getModules();
      for (const menuItem of menu) {
        const module = modules.find((m: any) => m.docId === menuItem.id);
        if (!module) {
          delete menuItem.type;
          delete menuItem.url;
          delete menuItem.addUrl;
        }
      }
    } catch (error) {
      console.error('Error fetching modules from Galigeo Cloud:', error);
    }

    // remove menu items where type is not defined and the array of maps is empty
    menu = menu.filter((menuItem: any) => menuItem.type || (Array.isArray(menuItem.maps) && menuItem.maps.length > 0));

    return menu;

  }

  public static async saveMenu(menu: any): Promise<any[]> {
    return await RESTUtils.postJson(
      `${PortalAppContext.getBackendUrl()}/feature/menu`,
      menu,
      {},
    );
  }

  public static async getCategories(): Promise<any> {
    return await RESTUtils.getJson(
      `${PortalAppContext.getBackendUrl()}/feature/menu/categories`,
      {},
    );
  }
}
